import { authorizedInstance } from "../config/axios"

export const processClinicalQAReports = async () => {
  const response = await authorizedInstance.post(
    `/quality-assurance/process-reports`
  )
  return response.data
}
